module.exports = __webpack_public_path__ + "static/media/cg-logo.04133bc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pc/cg-logo.png
// module id = 314
// module chunks = 0